export const COLLECTION_COMPOSITION_LIST: Record<string, string>[] = [
  {
    name: 'Шкаф под мойку 60 см',
    quantity: '1 шт',
  },
  {
    name: 'Шкаф с дверцей 60 см',
    quantity: '1 шт',
  },
  {
    name: 'Шкаф с 3-мя выдвижными ящиками 60\u00A0см',
    quantity: '1 шт',
  },
  {
    name: 'Шкаф под духовку 60 см',
    quantity: '1 шт',
  },
  {
    name: 'Верхний шкаф 60 см',
    quantity: '3 шт',
  },
  {
    name: 'Цоколь 240 см',
    quantity: '1 шт',
  },
];
